import { booleanAttribute, computed, Directive, input } from '@angular/core';
import type { ContextFamily, ContextTone } from '@quipex/shared/utils';
import { resolveTypographyClass } from './color';

@Directive({
    selector: '[qpxModalTitle]',
    host: {
        '[class]': 'className()',
    },
})
export class QpxModalTitle {
    public readonly context = input<
        ContextFamily | undefined,
        ContextFamily | '' | undefined
    >(undefined, {
        alias: 'qpxModalTitle',
        transform: (value) => value || undefined,
    });

    public readonly tone = input<ContextTone>('default');
    public readonly decorative = input(false, { transform: booleanAttribute });

    protected readonly className = computed(() => {
        return [
            'text-modal-title',
            'm-0',
            resolveTypographyClass(
                this.context(),
                this.tone(),
                this.decorative()
            ),
        ].join(' ');
    });
}

@Directive({
    selector: '[qpxModalHeadline]',
    host: {
        '[class]': 'className()',
    },
})
export class QpxModalHeadline {
    public readonly context = input<
        ContextFamily | undefined,
        ContextFamily | '' | undefined
    >(undefined, {
        alias: 'qpxModalHeadline',
        transform: (value) => value || undefined,
    });

    public readonly tone = input<ContextTone>('default');
    public readonly decorative = input(false, { transform: booleanAttribute });

    protected readonly className = computed(() => {
        return [
            'text-modal-headline',
            'm-0',
            resolveTypographyClass(
                this.context(),
                this.tone(),
                this.decorative()
            ),
        ].join(' ');
    });
}

@Directive({
    selector: '[qpxModalDescription]',
    host: {
        '[class]': 'className()',
    },
})
export class QpxModalDescription {
    public readonly context = input<
        ContextFamily | undefined,
        ContextFamily | '' | undefined
    >(undefined, {
        alias: 'qpxModalDescription',
        transform: (value) => value || undefined,
    });

    public readonly tone = input<ContextTone>('default');
    public readonly decorative = input(false, { transform: booleanAttribute });

    protected readonly className = computed(() => {
        return [
            'text-modal-description',
            'm-0',
            resolveTypographyClass(
                this.context(),
                this.tone(),
                this.decorative()
            ),
        ].join(' ');
    });
}
